import React from "react";

function Cities(props) {
  const { cities, limitCities } = props;

  const total_viewers = cities.reduce(
    (accumulator, index) => accumulator + index.value,
    0
  );

  return (
    <div className="card card-body card-dashboard-twentythree ht-xl-100p">
      <h6 className="card-title tx-14 mg-b-10">Principales ciudades</h6>
      <p className="mg-b-15">
        {limitCities && cities.length >= 5 ? "Las principales" : "Todas las"}{" "}
        ciudades desde las cuales se han conectado usuarios para ver tu evento.
      </p>
      <div className="card-dashboard-twentyone p-relative">
        <div className="location-list list-group">
          {cities
            .sort((a, b) => {
              if (a.value > b.value) {
                return -1;
              }
              if (a.value < b.value) {
                return 1;
              }

              return 0;
            })
            .map(function (city, index) {
              const total =
                total_viewers > 0
                  ? parseInt((city.value * 100) / total_viewers, 10)
                  : 0;
              if (limitCities && index >= 5) {
                return null;
              }
              return (
                <div key={city.label} className="list-group-item">
                  <span style={{ textTransform: "capitalize" }}>
                    {city.label === "?" ? "No identificada" : city.label}
                  </span>
                  <span>{city.value}</span>
                  <div className="progress">
                    <div
                      className={`progress-bar wd-${
                        Math.round(total / 5) * 5
                      }p bg-purple`}
                      role="progressbar"
                      aria-valuenow={total}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              );
            }, this)}
        </div>
      </div>
      {cities.length > 4 && (
        <button className="view-more" onClick={props.onMoreClick}>
          Ver {limitCities ? `Todas (${cities.length})` : "menos"}
        </button>
      )}
    </div>
  );
}

export default Cities;
